import { useFormContext } from "react-hook-form"

import FaIcon from "components/FontAwesomeIcon"
import { ErrorMessage } from "components/forms/FormElements"

const Quantity: React.FC = () => {
  const rhf = useFormContext()
  return (
    <div className="my-5">
      <label htmlFor="quantity" className="block text-sm">
        Quantity
      </label>
      <div className="flex items-stretch">
        <button
          type="button"
          className="p-[1.5rem] bg-primary hover:opacity-75 transition-colors text-white rounded-l-lg flex items-center"
          onClick={() => {
            // is equals 1 dont set
            if (rhf.getValues("quantity") === 1) return
            // if null set 1
            if (!rhf.getValues("quantity")) rhf.setValue("quantity", 1)
            // otherwise decrement
            rhf.setValue("quantity", rhf.getValues("quantity") - 1)
          }}
        >
          <FaIcon icon="minus" />
        </button>
        <input
          type="number"
          className="w-[125px] border-t-4 border-b-4 border-gray-200 text-center"
          {...rhf.register("quantity", {
            valueAsNumber: true,
            min: 1,
            max: 100,
            required: true,
            onChange: e => {
              if (e.target.valueAsNumber < 1) {
                rhf.setValue("quantity", 1)
              }
            }
          })}
        />
        <button
          type="button"
          className="p-[1.5rem] bg-primary hover:opacity-75 transition-colors text-white rounded-r-lg flex items-center"
          onClick={() => {
            // is equals 100 dont set
            if (rhf.getValues("quantity") === 100) return
            // if null set 1
            if (!rhf.getValues("quantity")) rhf.setValue("quantity", 1)
            // otherwise increment
            rhf.setValue("quantity", rhf.getValues("quantity") + 1)
          }}
        >
          <FaIcon icon="plus" />
        </button>
      </div>
      {rhf.formState.errors.quantity && (
        <ErrorMessage>
          {rhf.formState.errors.quantity?.type === "required"
            ? "Choose a quantity"
            : "Choose a quantity between 1 and 100"}
        </ErrorMessage>
      )}
    </div>
  )
}

export default Quantity
